import { Schema } from '@/interfaces/schema';
import { EntityResource } from './entity.resource';

/**
 * Resource schem
 *
 * @export
 * @class SchemaResource
 * @extends {EntityResource<Schema>}
 */
export class SchemaResource extends EntityResource<Schema> {
  public getFields = {
    id: true,
    name: true,
    schema: true
  };

  public listFields = {
    id: true,
    name: true
  };

  constructor() {
    super({
      entityName: 'schema'
    });
  }
}

export const schemaResource = new SchemaResource();
